import { IShow } from "@eagerdog/interfaces";

import { conformationOf } from "./stored";
import { ConformationStream } from "./types";

/**
 * Preferred candidates for a stream's Best in Show picker:
 * Regular = saved Group 1 winners; Altered = saved Altered BOBs;
 * Novice Puppy / Veteran / Brace = that level's saved BOBs.
 */
export function preferredShowIds(show: IShow, stream: ConformationStream): string[] {
  const results = conformationOf(show);
  if (stream === "regular") {
    return (results?.group_results || [])
      .filter((row) => (row.stream || "regular") === "regular" && row.placements?.[0])
      .map((row) => row.placements[0]);
  }
  if (stream === "altered") {
    return (results?.breed_results || [])
      .filter((row) => row.stream === "altered")
      .map((row) => row.awards?.best_of_breed || row.best_of_breed || "")
      .filter(Boolean);
  }
  const level = stream === "veteran" ? "veteran" : stream === "brace" ? "brace" : "novice_puppy";
  return (results?.non_licensed_breed_results || [])
    .filter((row) => row.level === level && row.best_of_breed)
    .map((row) => row.best_of_breed as string);
}

/** Saved Regular Best of Breed ids within one breed group (Group picker preference). */
export function groupBobIds(show: IShow, breedGroup: string): string[] {
  return (conformationOf(show)?.breed_results || [])
    .filter((row) => row.breed_group === breedGroup && (row.stream || "regular") === "regular")
    .map((row) => row.awards?.best_of_breed || row.best_of_breed)
    .filter((id): id is string => !!id);
}
